export let api = "https://pocket.pvpcraft.ca/api";



// WEBPACK FOOTER //
// ./src/consts.js